import { type Masked, graphql, unmask } from '~/contentful/graphql';
import { ArticleType } from '~/contentful/model/articleType';

export const ArticleCta_ArticleFragment = graphql(`
  fragment ArticleCta_ArticleFragment on Article {
    type
  }
`);

export function getArticleCta(data: Masked<typeof ArticleCta_ArticleFragment>) {
  const { type } = unmask<typeof ArticleCta_ArticleFragment>(data);
  switch (type) {
    case ArticleType.GENERIC:
      return 'Read the article';
    case ArticleType.STORY:
      return 'Read the story';
    case ArticleType.GRANTEE:
    case ArticleType.MELLON_IN_THE_NEWS:
      return 'Read the news';
    case ArticleType.PAST_EVENT:
      return 'Watch event';
    case ArticleType.REPORT:
      return 'Read the report';
    case ArticleType.VOICES:
      return 'Read the essay';
  }
}
